module.exports = {
    namespace: "radio",
    checked: '',
    unchecked:''
}


/** WEBPACK FOOTER **
 ** ./src/styles/RadioItemTemplate-style.js
 **/